<template>
  <div ref="app" :class="['template04', { border: isBorder }]">
    <div class="text">
      <el-input
        v-model="contentData.title"
        :rows="2"
        resize="none"
        type="textarea"
        class="title"
      ></el-input>
      <div class="trainTeacher train">培训讲师</div>
      <el-input v-model="contentData.teacher" class="teacher"></el-input>
      <div class="trainTime train">培训时间</div>
      <div class="trainContent train">培训内容</div>
      <el-input
        v-model="contentData.content"
        type="textarea"
        class="content"
        :rows="4"
        resize="none"
      ></el-input>
      <el-input v-model="contentData.date" class="date"></el-input>
      <div class="qrcode">
        <div class="des">
          <p>保存图片或使用微信</p>
          <p>扫一扫识别二维码</p>
        </div>
        <div class="code">
          <img :src="qrCode" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'Template04',
  props: {
    qrCode: {
      type: String,
      default: '',
    },
    templateBackground: {
      type: String,
      default: '',
    },
    isBorder: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      contentData: {
        title: '企业如何做好\n生产与管理',
        teacher: '某老师',
        content:
          '1、培训内容培训内容培训内容培训内容内容 2、培训内容培训内容培训内容培训内容内容 3、培训内容培训内容培训内容培训内容内容 4、培训内容培训内容培训内容培训内容内容',
        date: '2021.06.03 — 2021.06.06',
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      const $app = this.$refs.app
      const standardScale = 2208 / 1242
      window.addEventListener(
        'resize',
        _.debounce(() => {
          const docHeight = document.querySelector('.design-wrapper').clientHeight
          const docWidth = document.querySelector('.design-wrapper').clientWidth

          const currentScale = docHeight / docWidth
          let [scale, translate] = [0, 0]
          if (currentScale < standardScale) {
            // 以高度计算
            scale = docHeight / 2208
            const shouleWidth = 1242 * scale
            const offsetWidth = docWidth - shouleWidth
            translate = offsetWidth > 0 ? `translate(${offsetWidth / 2}px, 0)` : ''
          } else {
            // 以宽度计算
            scale = docWidth / 1242
            const shouleHeight = 2208 * scale
            const offsetHeight = docHeight - shouleHeight
            translate = offsetHeight > 0 ? `translate(0, ${offsetHeight / 2}px)` : ''
          }
          console.log(translate)
          // background:url(${this.templateBackground});
          $app.style.cssText = `
            transform: scale(${scale});
            min-width: 1242px;
            min-height: 2208px;
          `
        }),
        200,
      )

      if (document.createEvent) {
        var event = document.createEvent('HTMLEvents')
        event.initEvent('resize', true, true)
        window.dispatchEvent(event)
      } else if (document.createEventObject) {
        window.fireEvent('onresize')
      }
    })
  },
}
</script>
<style lang="scss" scoped>
@font-face {
  font-family: Alibaba-PuHuiTi-Bold;
  src: url('../../../../../font/Alibaba-PuHuiTi-Bold.otf');
}
@font-face {
  font-family: Source Han Sans CN-Medium;
  src: url('../../../../../font/SourceHanSansCN-Medium.otf');
}
@font-face {
  font-family: Source Han Sans CN-Regular;
  src: url('../../../../../font/SourceHanSansCN-Regular.otf');
}
.template04 {
  overflow: hidden;
  position: relative;
  min-width: 1242px;
  min-height: 2208px;
  background: url('../../../../../assets/posterTemplate/template04.png') no-repeat;
  background-size: 100% 100%;
  .text {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    .train {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-size: 52px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #00127c;
    }
    .trainTeacher {
      top: 656px;
    }
    .trainTime {
      top: 923px;
    }
    .trainContent {
      top: 1201px;
    }
    ::v-deep.el-input {
      input {
        vertical-align: top;
        box-sizing: border-box;
        border: 0;
        border-radius: 0;
        height: auto;
        background-color: transparent;
        color: #ffffff;
      }
    }
    ::v-deep.el-textarea {
      textarea {
        box-sizing: border-box;
        border: 0;
        border-radius: 0;
        height: auto;
        background-color: transparent;
        color: #ffffff;
      }
    }
    ::v-deep.title {
      position: absolute;
      top: 106px;
      left: 50%;
      transform: translateX(-460px);
      display: block;
      width: 960px;
      textarea {
        padding: 0;
        height: 352px;
        font-size: 152px;
        box-sizing: border-box;
        font-family: Source Han Sans CN;
        font-weight: 700;
        line-height: 175px;
        overflow: hidden;
        text-align: center;
        color: #fff;
        &:focus {
          border: 2px dashed #ff7b33;
          border-radius: 0;
        }
      }
    }
    ::v-deep.teacher {
      position: absolute;
      top: 757px;
      left: 412px;
      display: block;
      width: 400px;
      input {
        font-size: 82px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #00127c;
        line-height: 250px;
        height: 90px;
        text-align: center;
        &:focus {
          border: 2px dashed #ff7b33;
          border-radius: 0;
        }
      }
    }
    ::v-deep .content {
      display: flex;
      flex-wrap: wrap;
      position: absolute;
      top: 1320px;
      left: 50%;
      transform: translateX(-50%);
      width: 740px;
      height: 229px;
      textarea {
        padding: 0 10px;
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        text-align: left;
        color: #00127c;
        line-height: 65px;
        &:focus {
          border: 2px dashed #ff7b33;
          border-radius: 0;
        }
      }
    }
    ::v-deep.date {
      position: absolute;
      top: 1028px;
      left: 50%;
      transform: translateX(-50%);
      display: block;
      width: 700px;
      input {
        font-size: 51px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #00127c;
        text-align: center;
        &:focus {
          border: 2px dashed #ff7b33;
          border-radius: 0;
        }
      }
    }
    .qrcode {
      position: absolute;
      top: 1848px;
      left: 165px;
      display: flex;
      align-items: center;
      .code {
        width: 284px;
        height: 284px;
        background: #ffffff;
        margin-left: 76px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .des {
        font-size: 56px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #ffffff;
        line-height: 94px;
        text-align: right;
        letter-spacing: 10px;
      }
    }
  }
  &.border {
    ::v-deep.el-input {
      input {
        border: 2px dashed #c9c9c9;
      }
    }
    ::v-deep.el-textarea {
      textarea {
        border: 2px dashed #c9c9c9;
      }
    }
  }
  img {
    height: 100%;
    -moz-user-select: none; /*火狐*/
    -webkit-user-select: none; /*webkit浏览器*/
    -ms-user-select: none; /*IE10*/
    -khtml-user-select: none; /*早期浏览器*/
    user-select: none;
    pointer-events: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
}
</style>
